const NOTIFICATION_STORAGE_KEY = '_flash_notification';

export interface NotificationData {
  heading?: string;
  variant?: string;
  message?: string;
  duration?: number;
}

class Notification {
  static get notification(): NotificationData {
    try {
      const _notification = sessionStorage.getItem(NOTIFICATION_STORAGE_KEY);

      if (!_notification) return {};

      return JSON.parse(_notification) as NotificationData;
    } catch {
      return {};
    }
  }

  static set notification(notificationParams: NotificationData) {
    try {
      sessionStorage.setItem(
        NOTIFICATION_STORAGE_KEY,
        JSON.stringify(notificationParams)
      );
    } catch {}
  }

  static flash(
    heading: string,
    variant = 'info',
    message?: string,
    duration?: number
  ): void {
    this.notification = {
      heading,
      variant,
      message,
      ...(duration !== undefined && { duration }),
    };
  }

  static clear(): void {
    try {
      sessionStorage.removeItem(NOTIFICATION_STORAGE_KEY);
    } catch {}
  }
}

export default Notification;
